module.exports = "/_next/static/images/icon3-3291a340bc6afb10b06c9f96497b73b9.png";